/**
*
* Wrapper
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import loadable from '@loadable/component';

import { isEqual } from 'lodash';

import { setNotification } from 'components/Notifications/actions';

// import PortalWithRef from 'components/PortalWithRef';

import {
  selectAnythingFn
} from 'containers/EditTemplate/selectors';

import setLanguageContent from 'helpers/setLanguageContent';

import throttle from 'helpers/throttle';

import SelectDropDown from 'components/SelectDropDown';

import VideoPlayer from 'components/VideoPlayer';
import Input from 'components/Input';
import CheckboxInput from 'components/CheckboxInput';
import setCssMediaQuery from 'helpers/setCssMediaQuery';
import TextArea from 'components/TextArea';
import Loader from 'components/Loader';




import hasBackgroundElement from 'helpers/hasBackgroundElement';
import getPageSlug from 'components/Templates/general/getPageSlug';
const TextEditor = loadable(() => import('components/Templates/dynamics/TextEditor'));
const MiniWrapperNav = loadable(() => import('./MiniWrapperNav'));
import WrapperMinNavActionEditText from './styles/WrapperMinNavActionEditText';
import WrapperIsSaving from './styles/WrapperIsSaving';

import mixFormStyling from './helpers/mixFormStyling';

import WrapperWrapper from './styles/WrapperWrapper';
import WrapperHandleClick from './styles/WrapperHandleClick';



class Wrapper extends React.Component {

  constructor(props) {
    super();
    this._isMounted = false;

    this.wrapperRef = React.createRef();

    this.handleIsEditable = this.handleIsEditable.bind(this);
    this.handleOpenEditor = this.handleOpenEditor.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.setHover = this.setHover.bind(this);
    this.removeHover = this.removeHover.bind(this);
    this.handleTriggerOnClick = this.handleTriggerOnClick.bind(this);
    this.handleLink = this.handleLink.bind(this);
    this.setLink = this.setLink.bind(this);
    this.removeOut = this.removeOut.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
    this.handleScrollDrag = this.handleScrollDrag.bind(this);
    this.handleScrollDragDown = this.handleScrollDragDown.bind(this);
    this.handleScrollDragUp = this.handleScrollDragUp.bind(this);
    this.thisResize = this.thisResize.bind(this);
    
    this.state = {
      isEditable: false,
      isHover: false,
      styling: null,
      content: null,
      isMouseDown: false,
      startX: 0,
      scrollLeft: 0,
      clickTarget: '',
      slider: '',
      styling: props.styling,
      hold: true,
      editorData: props.editorData
    };
  }


  stopPropagation(event) {
    const {
      isEditor,
    } = this.props;


    const elementTextEditor = document.getElementById('TextEditorControlsWrapperWithId');

    if (elementTextEditor && event.target && event.target === elementTextEditor || elementTextEditor && elementTextEditor.contains(event.target)) {
      return;
    }

    event.stopPropagation();

    if (isEditor && !event.target.closest('.DraftEditor-root')) event.preventDefault();

  }


  setLink() {

    const {
      baseUrlTamplate,
      defaultUrl,
      pages,
      typeOfStyle,
      language,
      editorData,
    } = this.props;

    const {
      componentPayload
    } = editorData;

    const customUrl = componentPayload && componentPayload.content && componentPayload.content[typeOfStyle] && componentPayload.content[typeOfStyle].linkData && componentPayload.content[typeOfStyle].linkData[language ? language : 'en'] && componentPayload.content[typeOfStyle].linkData[language ? language : 'en'].customUrl;

    if (customUrl && customUrl.includes('https://') || customUrl && customUrl.includes('http://')) {
      return customUrl;
    }


    let thisPage;

    for (let i = 0; i < pages.length; i++) {
      if (componentPayload && componentPayload.content && componentPayload.content[typeOfStyle] && componentPayload.content[typeOfStyle].linkData && componentPayload.content[typeOfStyle].linkData[language ? language : 'en'].pageId === pages[i].pageId) {
        thisPage = pages[i];
      }
    }

    const thisBaseTemplateUrl = baseUrlTamplate ? baseUrlTamplate : '';

    if (thisPage) return getPageSlug(pages, thisPage, thisBaseTemplateUrl);

    if (defaultUrl && defaultUrl.includes('https://') || defaultUrl && defaultUrl.includes('http://')) return defaultUrl;

    if (defaultUrl) return getPageSlug(pages, defaultUrl, thisBaseTemplateUrl);

  }

  setHover(e) {
    
    const {
      isEditor,
      hasTextEditor
    } = this.props;

    if (isEditor && !hasTextEditor) this.setState({
      isHover: true
    });
  }

  removeOut(e) {

    const {
      isEditor,
      type,
      handleClick,
      hasTextEditor,
      typeOfStyle
    } = this.props;

    if (isEditor && !type && !handleClick && !hasTextEditor && typeOfStyle !== 'wrapper') this.setState({
      isHover: false
    });
  }

  removeHover(e) {
    
    const {
      isEditor,
      hasTextEditor,
      canDrag
    } = this.props;

    if (isEditor && !hasTextEditor) return this.setState({
      isHover: false,
      isMouseDown: false
    });

    if (canDrag) return this.setState({
      isHover: false,
      isMouseDown: false
    });
  }

  handleIsEditable(isHide) {

    const {
      isEditor
    } = this.props;

    if (isEditor) {

        if (isHide && typeof isHide === 'boolean') {

          return this.setState({
            isEditable: false,
            isHover: false
          });
        }

        const {
          editorData
        } = this.props;
  

        this.setState((state) => {
          return {
            isEditable: true,
            isHover: false
          };
        });


        this.handleOpenEditor(editorData, true);
    }

  }


  handleOpenEditor(data, hasText) {


    const {
      openEditor,
      type,
      helpers
    } = this.props;

    const { setCurrentSection } = helpers;

    const isSavingThis = this.props.isSaving && this.props.editorData && this.props.editorData.sectionId && this.props.isSaving.includes(this.props.editorData.sectionId) || this.props.isSaving && this.props.editorData && this.props.editorData.sectionIdLinked && this.props.isSaving.includes(this.props.editorData.sectionIdLinked);
    if (isSavingThis) return; 

    if (setCurrentSection) {
      setCurrentSection({...data, hasTextEditor: type === 'text'});
    }
    
    
    const thisStatePayload = {
      isEditable: type === 'text',
    };
    if (type === 'text') thisStatePayload.isHover = false;

    this.setState(thisStatePayload);
    return data;


  }

  handleLink(e) {

    e.preventDefault();
    e.stopPropagation();
    const {
      href,
      target,
      defaultUrl,
      onClickCallback
    } = this.props;

    if (onClickCallback) onClickCallback();

    const isFullUrlHref =  href && href.includes('https://') || href && href.includes('http://');

    if (href && target && target !== '_parent' || isFullUrlHref) {
      let otherWindowUrl = window.open(href, target ? target : isFullUrlHref ? '_blank' : '_self');
      otherWindowUrl.opener = null;
      return;

    }
 
    if (href) return browserHistory.push(href);

    const thisUrl = this.setLink();

    const isFullUrl = thisUrl && thisUrl.includes('https://') || thisUrl && thisUrl.includes('http://');

    if (!isFullUrl && (!target || target === '_parent') && thisUrl) return browserHistory.push(thisUrl);

    if (defaultUrl && thisUrl || thisUrl && target && target !== '_parent' || isFullUrl) {
      let otherWindow = window.open(thisUrl, target ? target : isFullUrl ? '_blank' : '_self');
      otherWindow.opener = null;
      return;
    }



  }

  handleTriggerOnClick(event) {
    event.preventDefault();
    const {
      handleClick,
      clickValue
    } = this.props;

    event.stopPropagation();
    if (handleClick) handleClick(clickValue);

    return null;
  }

  handleScrollDragDown(event) {
    let slider = event.target;
    slider = slider.closest("[data-candrag]");

    this.setState({
      isMouseDown: true,
      startX: event.pageX - slider.offsetLeft,
      scrollLeft: slider.scrollLeft,
      slider: slider
    });
  }

  handleScrollDragUp(event) {

    this.setState({
      isMouseDown: false,
    });

  }

  handleScrollDrag = throttle((event) => {

      if (this._isMounted) {

        const {
          canDrag
        } = this.props;
    
 
    
        if (
          canDrag
        ) {
    
          const {
            slider,
            isMouseDown
          } = this.state;
    
          
          if(isMouseDown) {
            event.preventDefault();
            const x = event.pageX - slider.offsetLeft;
            const shift = x - this.state.startX;
            slider.scrollLeft = this.state.scrollLeft - shift;
          } 
    
        }
        
    
      }

  }, 1);

  handleOnClick(event, hasText) {

    const elementTextEditor = document.getElementById('TextEditorControlsWrapperWithId');

    if (elementTextEditor || elementTextEditor && event.target && event.target === elementTextEditor || elementTextEditor && elementTextEditor.contains(event.target)) {
      return;
    }



    const {
      forceStopPropagation,
      type,
      openEditor,
      editorData,
      handleClick,
      isEditor,
      clickValue,
      handleFormChange,
      formData,
      showSectionsEdit,
      typeOfStyle,
      isCurrent
    } = this.props;

    const {
      isEditable
    } = this.state;



    if (type !== 'checkbox' || isEditable) event.preventDefault();
    if (forceStopPropagation && type !== 'checkbox') event.stopPropagation();
 
    if (isCurrent && isEditable && showSectionsEdit === typeOfStyle) {
      event.stopPropagation();
      return;
    }
    
    
    if (type === 'text') {
      event.stopPropagation();
    }

    if (handleFormChange && !isEditor && type === 'checkbox') {
      event.stopPropagation();

      const {
        type,
        value,
        inputId
      } = formData;

      return handleFormChange({
        type: type,
        updateType: inputId,
        value: value
      }, 'checkbox');
    }

    if (isEditor) {
      event.stopPropagation();
      event.preventDefault();
      return this.handleOpenEditor(editorData);
    }
    if (handleClick && !isEditor) {
      event.stopPropagation();
      return handleClick(clickValue);
    }
 
    return null;
  }



  thisResize = throttle(() => {
    if (!this._isMounted) return;
    const thisCanDrag = this.wrapperRef && this.wrapperRef.current && this.wrapperRef.current.clientWidth < this.wrapperRef.current.scrollWidth;
    if (this.props.isDraggableCallback) this.props.isDraggableCallback(thisCanDrag);
  }, 10);

  

  static getDerivedStateFromProps(props, state) {

    const isSavingThis = props.isSaving && props.isEditor && props.editorData && props.editorData.sectionId && props.isSaving.includes(props.editorData.sectionId) || props.isSaving && props.isEditor && props.editorData && props.editorData.sectionIdLinked && props.isSaving.includes(props.editorData.sectionIdLinked);

    if (isSavingThis || state.isSaving && !isSavingThis) {
      return {
        isSaving: isSavingThis,
      };
    }

    if (state.isSaving && !props.isCurrent && !isSavingThis && state.isCurrent && props.styling && !isEqual(state.styling, props.styling)) {
      return {
        isCurrent: props.isCurrent,
        isSaving: isSavingThis
      };

    }


    const isStyling = props.styling && !isEqual(state.styling, props.styling);
    const isSaveUpdate = isSavingThis !== state.isSaving;
    const isCurrentUpdate = !props.isCurrent && !isSavingThis && state.isCurrent;
    const isEditorState = !isEqual(state.editorData, props.editorData);
    if (
      isStyling ||
      isSaveUpdate ||
      isCurrentUpdate ||
      isEditorState
    ) {

      const newStatePayload = {};

      if (isStyling) newStatePayload.styling = props.styling;
      if (isSaveUpdate) newStatePayload.isSaving = isSavingThis;
      if (isCurrentUpdate) newStatePayload.isSaving = isSavingThis;
      if (isEditorState) newStatePayload.editorData = props.editorData;
      if (Object.keys(newStatePayload).length) return newStatePayload;
    }
    return null;
  }

  componentDidUpdate(prevProps) {


    if (this.props.isDraggable && this.props.isEditor && this.props.viewPort !== prevProps.viewPort) {
      setTimeout(() => {
        if (!this._isMounted) return;
        this.thisResize();
      }, 500);
    }

  }


  componentDidMount() {
    this._isMounted = true;

    const {
      frameRef
    } = this.props;

    const frameWindow = frameRef && document.querySelector(frameRef) && document.querySelector(frameRef).contentWindow ? document.querySelector(frameRef).contentWindow : window;

    
   if (this.props.isDraggable) {
    frameWindow.addEventListener('resize', this.thisResize);
   
    setTimeout(() => {
      if (!this._isMounted) return;
      this.thisResize();
    }, 500);
   }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.props.isDraggable) {

      const {
        frameRef
      } = this.props;
  
      const frameWindow = frameRef && document.querySelector(frameRef) && document.querySelector(frameRef).contentWindow ? document.querySelector(frameRef).contentWindow : window;
  
      frameWindow.removeEventListener('resize', this.thisResize);
    }
  }


  render() {

    const {
      isMouseDown,
      styling,
      isEditable,
      isHover
    } = this.state;

    const {
      isEditor,
      viewPort,
      type,
      typeOfStyle,
      video,
      stream,
      streams,
      pages,
      pageIdLinked,
      sectionIdLinked,
      helpers,
      language,
      formData,
      formState,
      handleFormChange,
      selectData,
      selectValue,
      handleSelectChange,
      as,
      editorData,
      defaultValues,
      backgroundImage,
      href,
      target,
      handleClick,
      innerRef,
      defaultUrl,
      viewRef,
      frameRef,
      isCurrent,
      inputError,
      checked,
      showSectionsEdit,
      isPreview,
      content,
      baseUrlTamplate,
      disableLinkEdit,
      customStyleWrapper,
      windowWidth,
      lineClamp,
      canDrag,
      isDraggable,
      contentWrapperRef,
      classes
    } = this.props;

    const {
      componentPayload,
      editorType
    } = editorData;

    const {
      sectionId,
    } = componentPayload;


    const { customStyles } = editorData;

    const getBackgroundVideo = hasBackgroundElement(styling, typeOfStyle, windowWidth, 'video');
    const getBackgroundImage = hasBackgroundElement(styling, typeOfStyle, windowWidth, 'background-image');

    const mixStyles = setCssMediaQuery(styling, typeOfStyle, viewPort, frameRef);
 
    const thisBaseTemplateUrl = baseUrlTamplate ? baseUrlTamplate : '';


    let formMixStyles;
    let placeholderMixStyles;
    let counterMixStyles;
    let bulletMixStyles;


    if (type === 'form') {

      const setMixingForForm =  mixFormStyling(styling, typeOfStyle, viewPort);

      if (setMixingForForm) {
        formMixStyles = setMixingForForm.formMixStyles;
        placeholderMixStyles = setMixingForForm.placeholderMixStyles;
        counterMixStyles = setMixingForForm.counterMixStyles;
      }

    }

    if (typeOfStyle === 'listElement') {
      const setMixingForBullet =  mixFormStyling(styling, typeOfStyle, viewPort);
      
      if (setMixingForBullet) {
        bulletMixStyles = setMixingForBullet.bulletMixStyles;
      }

    }
 
    const backgroundVideoContent = getBackgroundVideo && getBackgroundVideo.video && !getBackgroundVideo.isHidden ? (
      <VideoPlayer
        key={`Wrapper-VideoPlayerBackground-${sectionId}-${JSON.stringify(getBackgroundVideo.video)}`}
        autoplay={true}
        controls={false}
        loop={true}
        sources={getBackgroundVideo.video}
        isBackground={true}
        muted={true}
        isEditor={isEditor}
        forceRawSource={true}
        backgroundColor={'transparent'}
        hideLoader={true}
        thisStyles={
          {
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            'object-fit': 'cover',
          }
        }
      />
    ) : '';

    let streamContent = type === 'stream' && stream ? (() => {
      let thisStream;

      for (let i = 0; i < streams.length; i++) {
        if (streams[i].streamId === stream) {
          thisStream = streams[i];
          break;
        }
      }
      return thisStream;

    })() : '';

    if (streamContent) {
      streamContent = (
        <VideoPlayer
          autoplay={true}
          muted={true}
          controls={true}
          isLive={true}
          sources={{
          muxPlaybackId: streamContent.muxPlaybackId
        }}
        />
      )
    }

    const vidoContent = video && video ? video[language] : undefined;

    const videoContent = type === 'video' ? (
      <VideoPlayer
        key={`Wrapper-VideoPlayer-${sectionId}-${typeOfStyle}-${JSON.stringify(vidoContent)}`}
        autoplay={false}
        controls={true}
        sources={video && video ? video[language] : undefined}
        isEditor={isEditor}
      />
    ) : '';

    const textContent = type === 'text' ? (
      <TextEditor
        isEditor={isEditor}
        viewPort={viewPort}
        isEditable={isEditable}
        handleIsEditable={this.handleIsEditable}
        typeOfStyle={typeOfStyle}
        componentPayload={this.state.editorData.componentPayload}
        pageIdLinked={pageIdLinked}
        sectionIdLinked={sectionIdLinked}
        helpers={helpers}
        defaultValues={defaultValues}
        styling={mixStyles}
        viewRef={viewRef}
        frameRef={frameRef}
        contentWrapperRef={contentWrapperRef}
        isCurrent={isCurrent && showSectionsEdit === typeOfStyle}
        customStyles={customStyles}
        saveChanges={this.saveChanges}
        baseUrlTamplate={thisBaseTemplateUrl}
        disableLinkEdit={disableLinkEdit}
        bulletStyling={typeOfStyle === 'listElement' ? bulletMixStyles : {}}
        editorViewportContent={windowWidth}
        windowWidth={windowWidth}
        content={this.state.content}
        isSaving={this.state.isSaving}
      />      
    ) : '';


    const isCheckBox = type === 'checkbox';

    const checkBoxContent =  isCheckBox ? (
      <CheckboxInput
        checked={checked}
        onChange={this.handleOnClick}
        thisStyles={
          {
            display: 'inline-block',
            'margin-right': '1rem',
            top: '5px'
          }
        }
      />
    ) : '';

    const inputContent = type === 'form'  ? (
       formData.type === 'textarea' ? (
        <TextArea
          type={formData.type}
          label={setLanguageContent(formData, 'label', language) + (formData.isRequired ? ' *' : '')}
          placeholder={setLanguageContent(formData, 'placeholder', language)}
          value={formState[formData.inputId] ? formState[formData.inputId] : ''}
          updateType={formData.inputId}
          onChange={handleFormChange}
          error={inputError}
          thisStyles={formMixStyles}
          labelStylesCss={mixStyles}
          placeholderStylesCss={placeholderMixStyles}
          counterStyles={counterMixStyles}
        />
      ) : (
        <Input
          type={formData.type}
          label={setLanguageContent(formData, 'label', language) + (formData.isRequired ? ' *' : '')}
          placeholder={setLanguageContent(formData, 'placeholder', language)}
          value={formState[formData.inputId] ? formState[formData.inputId] : ''}
          updateType={formData.inputId}
          onChange={handleFormChange}
          error={inputError}
          thisStyles={formMixStyles}
          labelStylesCss={mixStyles}
          placeholderStylesCss={placeholderMixStyles}
          counterStyles={counterMixStyles}
        />
      )
    ) : '';

    
    let dropdownBackgroundColor;

    if (editorType === 'dayDropdown') {
      dropdownBackgroundColor = mixStyles.lastIndexOf('background-color:') >= 0 ? mixStyles.substring(
        mixStyles.lastIndexOf('background-color:') + 17, 
        mixStyles.indexOf(';', mixStyles.lastIndexOf('background-color:'))
      ).trim() : '';
    }


    const selectContent = type === 'select' ? (
      <SelectDropDown
        type={'text'}
        label={setLanguageContent(selectData, 'label', language)}
        hideLabel={selectData && !selectData.label ? true : false}
        dropdownBackgroundColor={dropdownBackgroundColor}
        labelStyles={{
          position: 'absolute',
          marginTop: 0,
          marginBottom: 0,
          top: '-2rem'
        }}
        labelWrapperStyles={{
          marginBottom: 0
        }}
        thisStyles={{
          'margin-bottom': '0'
        }}
        selected={selectValue || selectValue === 0 ? selectValue : selectData && selectData.firstHourIfNoRange ? selectData.firstHourIfNoRange : ''}
        options={selectData.options}
        onChange={handleSelectChange}
        dropdownItemStyles={selectData.dropdownItemStyles}
        selectedStyles={selectData.selectedStyles}
      />
    ) : '';



    const languageContent = content ? setLanguageContent(content, typeOfStyle, language) : '';

    const hasLink = defaultUrl || componentPayload.content && componentPayload.content[typeOfStyle] && componentPayload.content[typeOfStyle].linkData && componentPayload.content[typeOfStyle].linkData[language ? language : 'en'] && (componentPayload.content[typeOfStyle].linkData[language ? language : 'en'].pageId || componentPayload.content[typeOfStyle].linkData[language ? language : 'en'].customUrl) && !isEditor && pages ? this.setLink() : null;

    return (
      <WrapperWrapper
        isEditor={isEditor}
        isEditable={isEditable}
        isHover={isHover}
        thisStyling={type === 'form' ? null : mixStyles}
        customStyleWrapper={customStyleWrapper}
        lineClamp={lineClamp}
        onClick={!isEditor && href || !isEditor && hasLink || !isEditor && as === 'a' ? this.handleLink : isPreview || !isEditor && !isEditable ? this.handleOnClick : isEditable ? this.handleOnClick : this.stopPropagation} 
        onPointerDown={isEditor && !isPreview && !isEditable ? this.handleOnClick : !isEditor ? null : this.stopPropagation}
        backgroundImage={backgroundImage}
        isBackgroundHidden={getBackgroundImage && getBackgroundImage.isHidden}
        onMouseEnter={this.setHover}
        onMouseLeave={this.removeHover}
        onMouseOut={this.removeOut}
        onMouseMove={canDrag ? this.handleScrollDrag : null}
        onMouseDown={canDrag ? this.handleScrollDragDown : null}
        onMouseUp={canDrag ? this.handleScrollDragUp : null}
        as={ isEditable ? null : href || hasLink ? 'a' : as}
        href={href ? href : hasLink}
        target={target}
        rel={'noopener'}
        ref={isDraggable ? this.wrapperRef : innerRef}
        data-stylereference={`${sectionId}-${typeOfStyle}`}
        data-candrag={isDraggable ? true : null}
        isCurrent={showSectionsEdit && showSectionsEdit === typeOfStyle && isCurrent}
        isMouseDown={isMouseDown}
        canDrag={canDrag}
        className={classes}
        isButton={typeOfStyle.includes('button')}
      > 
 
        {backgroundVideoContent}
        {videoContent}
        {streamContent}
        {languageContent}
        {textContent}
        {inputContent}
        {checkBoxContent}
        {selectContent}
        {this.props.children}
        {
          isHover && handleClick ? (
            // <PortalWithRef viewRef={viewRef}>
              <WrapperHandleClick onClick={this.handleTriggerOnClick}>
                Click
              </WrapperHandleClick>
            // </PortalWithRef>
          ) : ''
        }
        {
          isHover && videoContent ? (
            <WrapperHandleClick onClick={this.handleOnClick}>
              Edit Video Container
            </WrapperHandleClick>
          ) : ''
        }
        {isHover && typeOfStyle === 'wrapper' && isEditor ? (<MiniWrapperNav {...this.props} />) : ''}
        {
        isHover && type === 'text' ? (
          <WrapperMinNavActionEditText> 
            {'Edit Text'}
          </WrapperMinNavActionEditText>
        ) : ''
        }

        { this.state.isSaving && typeOfStyle === 'wrapper' ?  (

          <WrapperIsSaving
          >
            <Loader thisStyles={
              {
                height: '2.5rem',
                width: '2.5rem',
                padding: 0,
                display: 'block',
                'max-width': 'initial',
                svgPath: {
                  fill: '#000'
                }
              }
            } />
          </WrapperIsSaving>

        ) : ''}
      </WrapperWrapper>
    );

  }
}

Wrapper.propTypes = {
  isEditor: PropTypes.bool,
  typeOfStyle: PropTypes.string,
  viewPort: PropTypes.string,
  type: PropTypes.string,
  streams: PropTypes.array,
  pages: PropTypes.array,
  pageIdLinked: PropTypes.string,
  sectionIdLinked: PropTypes.string,
  styling: PropTypes.object,
  editorData: PropTypes.object,
  openEditor: PropTypes.func,
  helpers: PropTypes.object,
  language: PropTypes.string,
  video: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
  content: PropTypes.object,
  formData: PropTypes.object,
  handleFormChange: PropTypes.func,
  handleClick: PropTypes.func,
  baseUrlTamplate: PropTypes.string,
  selectData: PropTypes.object,
  defaultUrl: PropTypes.string,
  clickValue: PropTypes.string,
  stream: PropTypes.string,
  formState: PropTypes.object,
  selectValue: PropTypes.string,
  handleSelectChange: PropTypes.func,
  as: PropTypes.string,
  defaultValues: PropTypes.object,
  backgroundImage: PropTypes.string,
  href: PropTypes.string,
  innerRef: PropTypes.object,
  viewRef: PropTypes.string,
  isCurrent: PropTypes.bool,
  target: PropTypes.string
};


const mapStateToProps = createStructuredSelector({
  showSectionsEdit: selectAnythingFn('showSectionsEdit'),
  hasTextEditor: selectAnythingFn('hasTextEditor'),
  isSaving: selectAnythingFn('isSaving'),

});

function mapDispatchToProps(dispatch) {
  return {
    dispatchSetNotification: payload => dispatch(setNotification(payload))
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
